import React, { Fragment } from 'react'
import { Row, Image, Table, Col, Divider, Typography } from 'antd'
import { prUrl } from '../config';
import { minioHost } from '../config';
import '../../App.css'

const { Title } = Typography;

const infoBoxCcolumns = [
    {
        title: '属性项',
        dataIndex: 'label',
        key: 'label',
        width: '30%',
        align: 'center',
    },
    {
        title: '属性值',
        dataIndex: 'value',
        key: 'value',
    },
]

const PersonInfoBox = (props) => {
    const { cn_name, country, state, party, occupation, encryptedWiki, introduction, qcode } = props.person
    return (
        <Row align='middle' justify='center'>
            <Divider orientation="left" ><Title align="left" level={4}>
                {encryptedWiki ? <a href={prUrl + encryptedWiki} target="blank">{cn_name}</a> : ''}</Title></Divider>
            <Col span={16} >
                <Row align='middle' justify='center'>
                    {/* {props.person.avatar ? <Image src={minioHost + props.person.avatar} preview={false} height={'40vh'}></Image> : ''} */}
                    {props.person.thumbImage?<Image src={prUrl + props.person.thumbImage} preview={false} height={'40vh'}></Image>:''}
                </Row>
                <Row align='middle' justify='center'>
                    {
                        (introduction || props.wikiIntro) ?
                            <Fragment>
                                <Divider orientation="left" ><Title align="left" level={4}>人物简介</Title></Divider>
                                {introduction ? <p style={{ "text-indent": "50px", fontSize: '16px' }} >{introduction}</p> : props.wikiIntro}
                            </Fragment>
                            : ''
                    }
                </Row>
            </Col>
            <Col span={6} offset={1}>
                {
                    qcode ? (props.infoboxhtml ?
                        <Row Row align='middle' justify='center'>
                            <table class="infoboxVcard" cellspacing="3" style={{ width: "50em", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: props.infoboxhtml }}></table>
                        </Row> : '')
                        : <Table columns={infoBoxCcolumns} showHeader={false}
                            dataSource={[
                                { key: 1, label: '国籍', value: country },
                                { key: 2, label: '州', value: state },
                                { key: 3, label: '政党', value: party },
                                { key: 4, label: '职业', value: occupation },
                            ]}
                            size="small" pagination={{ hideOnSinglePage: true }}></Table>
                }
            </Col>

        </Row>

    )
}

export default PersonInfoBox;